import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

let nextId = 0;

@Component({
  selector: 'ss-file-picker',
  templateUrl: './file-picker.component.html',
  styleUrls: ['./file-picker.component.scss'],
  standalone: false
})
export class FilePickerComponent {
  @ViewChild('fileInput', { static: true }) fileInput!: ElementRef<HTMLInputElement>;

  @Input() inputId = `ss-file-picker-${nextId++}`;
  @Input() accept = '';
  @Input() disabled = false;
  @Input() buttonLabel = 'Escolher arquivo';
  @Input() emptyLabel = 'Nenhum arquivo escolhido';
  @Input() hint = '';
  @Input() ariaLabel = '';
  @Input() fileName = '';

  @Output() fileChange = new EventEmitter<File | null>();

  choose(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files && input.files.length ? input.files[0] : null;
    this.fileName = file ? file.name : '';
    this.fileChange.emit(file);
  }

  clear(emit = false): void {
    this.fileInput.nativeElement.value = '';
    this.fileName = '';
    if (emit) this.fileChange.emit(null);
  }
}
